// imageSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  imageData: null,
};

const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    setImageData: (state, action) => {
      state.imageData = action.payload;
    },
    clearImageData: (state) => {
      state.imageData = null;
    },
  },
});

export const { setImageData, clearImageData } = imageSlice.actions;
export default imageSlice.reducer;
